import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { createContact } from 'src/_shared/api/graphql/custom/contacts/';
import { createUser, getUserById } from 'src/_shared/api/graphql/custom/users/';
import { updateContact } from '../../graphql/custom/contacts';

export const withNewExtendedUserLink = (Component) => {
	let { host } = window.location;
	host = host.replace('www.', '');
	return compose(
		graphql(gql(createUser), {
			props: (props) => ({
				onCreate(user) {
					return props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: { input: user },
					});
				},
			}),
		}),
		graphql(gql(createContact), {
			props: (props) => ({
				onCreateContact(contact) {
					return props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: { input: contact },
					});
				},
			}),
		}),
		graphql(gql(updateContact), {
			props: (props) => ({
				onUpdateContact(contact) {
					return props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: { input: contact },
					});
				},
			}),
		})
	)(Component);
};
